import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import i18n from "../i18n";
import { MI_CONTENIDO_ROOT } from "./paths";

export type MiContenidoBreadcrumbSegment = {
  label: string;
  /** Omit on the current (last) segment. */
  to?: string;
};

export type MiContenidoEntityBreadcrumbsProps = {
  segments: MiContenidoBreadcrumbSegment[];
};

export function miContenidoPerfilBreadcrumb(): MiContenidoBreadcrumbSegment {
  return { label: i18n.t("miContenido:sections.profile"), to: MI_CONTENIDO_ROOT };
}

export const MiContenidoEntityBreadcrumbs: React.FC<
  MiContenidoEntityBreadcrumbsProps
> = ({ segments }) => (
  <Breadcrumbs aria-label="breadcrumb">
    {segments.map((segment, index) => {
      const isLast = index === segments.length - 1;
      if (isLast || !segment.to) {
        return (
          <Typography key={`${segment.label}-${index}`} color="text.primary">
            {segment.label}
          </Typography>
        );
      }
      return (
        <Link
          key={`${segment.label}-${index}`}
          component={RouterLink}
          to={segment.to}
          underline="hover"
          color="inherit"
        >
          {segment.label}
        </Link>
      );
    })}
  </Breadcrumbs>
);
